export default "__VITE_ASSET__BX3cXvOU__"